import { CSS_BREAKPOINTS } from '@sbercloud/uikit-product-utils';
import { QuestionTooltip, Tooltip } from '@snack-uikit/tooltip';
import { PropsWithChildren, useState } from 'react';

import { useServerDataCtx } from '@/hooks/ctx';
import { useLayoutType } from '@/root/src/hooks';
import { SelfApiGlossaryRes } from '@/types/network';
import { isLargeThan } from '@/utils/layout';

import { GlossaryTooltipProps } from '../types';
import s from './styles.module.scss';
import { ToolTipContent } from './TooltipContent';

export function WithGlossaryTooltip({
  children,
  pathToGlossary,
  skipTooltip,
}: PropsWithChildren<GlossaryTooltipProps>) {
  const [tooltipContent, setTooltipContent] = useState<SelfApiGlossaryRes | null>(null);

  const { headers } = useServerDataCtx();
  const layoutType = useLayoutType(CSS_BREAKPOINTS, headers.xLayoutType);

  if (skipTooltip) return children;

  if (isLargeThan('tablet', layoutType)) {
    return (
      <Tooltip
        tip={
          <ToolTipContent
            setTooltipContent={setTooltipContent}
            tooltipContent={tooltipContent}
            pathToGlossary={pathToGlossary}
          />
        }
      >
        {children}
      </Tooltip>
    );
  }

  return (
    <div className={s.mobile_tooltip_wrapper}>
      {children}
      <QuestionTooltip
        tip={
          <ToolTipContent
            setTooltipContent={setTooltipContent}
            tooltipContent={tooltipContent}
            pathToGlossary={pathToGlossary}
          />
        }
      />
    </div>
  );
}
